import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WINDOW } from '@shared/services/window.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard  {
  constructor(@Inject(WINDOW) private window: Window,) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this.window.location.href = route.data['externalUrl'];

    return true;
  }

}
